module.exports = __webpack_public_path__ + "static/media/success_tip.6238e27c.jpg";